import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  AppBarProps,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactNode } from 'react';

export interface HeaderProps extends AppBarProps {
  title?: string;
  onMenuClick?: () => void;
  actions?: ReactNode;
  logo?: ReactNode;
}

export const Header = ({
  title,
  onMenuClick,
  actions,
  logo,
  children,
  ...props
}: HeaderProps) => {
  return (
    <AppBar position="static" {...props}>
      <Toolbar>
        {onMenuClick && (
          <IconButton
            size="l"
            edge="start"
            variant="standard"
            color="primary"
            aria-label="menu"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}
        {logo && <Box sx={{ mr: 2 }}>{logo}</Box>}
        {title && (
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
        )}
        {children && !title && <Box sx={{ flexGrow: 1 }}>{children}</Box>}
        {actions && <Box>{actions}</Box>}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
